import { z } from "zod";
import { emailSchema } from "../common/email.js";

export const devLoginSchema = z.object({
	email: emailSchema,
});

export type DevLoginPayload = z.infer<typeof devLoginSchema>;
